<template>
  <v-dialog v-model="dialog" max-width="300">
    <v-card>
      <div>
        <v-toolbar dark color="primary">
          {{ user.name }} Roles
          <v-spacer />
          <v-btn text small @click="store">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
          <v-btn text small @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div style="overflow-y: auto; max-height: 700px">
          <v-simple-table>
            <template #default>
              <thead>
                <tr>
                  <th>Permission</th>
                  <th>Allow</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.permission_id">
                  <th>{{ item.permission_id.toUpperCase().replace('_', ' ').replace(':', ' - ') }}</th>
                  <td>
                    <div style="height: 44px;display: flex;align-items: center;">
                      <v-switch v-model="item.allow" style="margin-top:0px;"
                                hide-details="auto" @change="() => { item.changed = !item.changed }" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { useWatchEffect } from '../../../../../../lib/utils'
import appAxios from '../../../../../../extra-functions/axios.extra'

const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'ManageUserRole',
  data() {
    return {
      dialog: false,
      items: [],
      user: {},
      loading: false,
    }
  },
  unmount() {
    clearWatchEffect()
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
    }),
  },
  watch: {
  },
  methods: {
    /**
     * Description
     * @param {any} user
     * @param {()=>void} success
     * @returns {any}
     */
    getUserRoles(user, success) {
      const axios = appAxios(this.token)
      watchEffect(async (onCleanup) => {
        const controller = new AbortController()
        onCleanup(() => {
          controller.abort()
        })
        const { data } = await axios.get(`/admin/users/${user.id}/permissions`, {
          signal: controller.signal,
        })
        this.dialog = true
        this.items = data
        this.user = user
        success?.()
      }, 'ManageUserRoleGetUserRoles')
    },
    async store() {
      try {
        const axios = appAxios(this.token)
        if (this.loading) return
        this.loading = true
        this.$alertSwalLoading('saving user permissions!')
        const items = this.items.filter(item => item.changed)
        await axios.put(`/admin/users/${this.user.id}/permissions`, items)
        this.items = this.items.map(item => {
          const { changed, ...data } = item
          return data
        })
        this.$alertSwalSuccess('successfully saved user permissions')
      } catch (e) {
        console.error(e)
        this.$alertSwalError(e)
      } finally {
        this.loading = false
      }
    },
    closeDialog() {
      this.dialog = false
    },
  },
}
</script>
